module.exports = __webpack_public_path__ + "img/RS2423RP+RS2423+.3102d98f.png";